import TooltippsBadges from "../../99-libs/tooltipps-badges";

("use strict");

function initializeCheckout() {
  checkTooltipps();
}

function checkTooltipps() {
  if (!document.querySelector(".checkout__table")) return;
  const tooltipps = new TooltippsBadges();
  tooltipps.init();
}

export default initializeCheckout;
